/** @format */

import {t} from 'i18next';

import {MultilineChartInterface, PointName} from 'components/charts/multiline-chart/model/common';
import {TooltipData, TooltipDataList} from 'components/charts/multiline-chart/model/tooltip';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {ALL_SENSOR_CHART_IDS} from 'pages/Home/DigitalCast/constants/allChartIds';

/**
 * Фильтрует строки тултипа по выбранным chart ids
 * Отсеивает тултипы с пустыми значениями
 * Конвертирует некоторые тултипы сенсоров в формат типа "Ещё 2 сенсора"
 * @param data
 * @param selectedIds
 */

const reworkTooltipData = (
  data: MultilineChartInterface<ChartIds>,
  selectedIds: ChartIds[],
): MultilineChartInterface<ChartIds> => {
  const result: TooltipDataList<ChartIds> = {};

  const points = Object.keys(data.tooltipDataList) as PointName[];

  points.forEach(point => {
    const tooltipData = data.tooltipDataList[point];
    const pointData: TooltipData<ChartIds> = {
      ...tooltipData,
    };

    pointData.rows =
      tooltipData.rows
        ?.filter(row => {
          const selected = selectedIds.includes(row.chartId);
          const hasValue = Boolean(row.value.primary || row.extraRows?.length);
          return selected && hasValue;
        })
        .map(row => {
          if (ALL_SENSOR_CHART_IDS.includes(row.chartId) && row.extraRows) {
            return {
              ...row,
              extraRows: row.extraRows.map(extraRow => {
                const parsed = parseInt(extraRow.label);
                const sensorsWord = t ? t('plurals.sensors', {count: parsed}) : parsed;
                if (isNaN(parsed)) {
                  return extraRow;
                }
                return {
                  ...extraRow,
                  label: `Ещё ${sensorsWord}`,
                };
              }),
            };
          }
          return row;
        }) || [];

    result[point] = pointData;
  });

  return {
    ...data,
    tooltipDataList: result,
  };
};

export default reworkTooltipData;
